module.exports = __webpack_public_path__ + "img/logo.2b9b58cb.png";